import Vue from 'vue'
import Vuex from 'vuex'
import { dataService} from "../shared";
import {GET_CATEGORIES, GET_FILTEROPTIONS, SEARCH} from "./mutation-types";

Vue.use(Vuex);

const state = {
    categories: [],
    filteroptions: [],
    searchresults: [],
};

const mutations = {
    [GET_CATEGORIES](state, categories)
    {
        state.categories = categories;
    },
    [GET_FILTEROPTIONS](state, options)
    {
        state.filteroptions = options;
    },
    [SEARCH](state, result)
    {
        state.searchresults = result;
    }
};

const actions = {
    async [GET_CATEGORIES]({ commit })
    {
        const categories = await dataService.getCategories();

        commit(GET_CATEGORIES, categories);
    },
    async [GET_FILTEROPTIONS]({ commit })
    {
        const options = await dataService.getFilterOptions();

        commit(GET_FILTEROPTIONS, options);
    },
    async [SEARCH]({ commit }, params)
    {
        const result = await dataService.search(params);

        commit(SEARCH, result);
    }
};

const getters = {};

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters
});

export default store;